import { Res, onQueryHaiIdParams, onSynHaiEnterParams, onSynHaiEnterRes } from '../components/app.type';
import { channelEnum, onSignTokenScene, roleName } from '../constants/app';
import httpClient from '../utils/httpClient';

export const checkHaiAuthorization = async () => {
  return httpClient({
    path: `/sts/role/${roleName}`,
    method: 'GET',
  });
};

export const onSynHaiEnter = async (params: onSynHaiEnterParams): Promise<Res<onSynHaiEnterRes>> => {
  return httpClient({
    path: `/hai/sync/${params.instanceId}/${params.region}`,
    method: 'GET',
  });
};

export const onStartHaiInstance = async (params: Pick<onQueryHaiIdParams, 'spaceKey'>): Promise<Res<any>> => {
  return httpClient({
    path: `/hai/${params.spaceKey}/start`,
    method: 'POST',
  });
};

export const onStatusCheck = async (spaceKey: string) => {
  return httpClient({
    path: `/workspace/${spaceKey}/status`,
    method: 'GET',
  });
};

// 通过spaceKey获取instanceId 暂时没用到
export const onQueryHaiId = async (params: onQueryHaiIdParams) => {
  return httpClient({
    path: `/hai/spaceKey/${params.spaceKey}/${params.region}`,
    method: 'GET',
  });
};

export const runWorkspace = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}/proxy/run`,
    method: 'PUT',
  });
};

export const queryHaiStatus = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}/status`,
    method: 'GET',
  });
};

export const onCheckPing = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}/ping`,
    method: 'GET',
  });
};

export const onSignToken = async (spaceKey: string) => {
  return httpClient({
    path: `/token/${onSignTokenScene}?spaceKey=${spaceKey}`,
    method: 'POST',
  });
};

export const onPostRegionUrl = async () => {
  return httpClient({
    path: `/token/${onSignTokenScene}`,
    method: 'GET',
  });
};

export const queryHaiBySpaceKey = async (spaceKey: string) => {
  return httpClient({
    path: `/hai/${spaceKey}`,
    method: 'GET',
  });
};

// 获取hai大账号剩余时长
export const queryHaiAccountFreeTime = async () => {
  return httpClient({
    path: `/hai_account`,
    method: 'GET',
  });
};

// GPU 获取token
export const queryWorkspaceToken = async (spaceKey: string) => {
  return httpClient({
    path: `/workspace/${spaceKey}/sessions`,
    method: 'GET',
  });
};

// 根据spaceKey获取workspace
export const queryWorkspaceBySpaceKey = async (spaceKey: string) => {
  return httpClient({
    path: `/workspace/v2/${spaceKey}`,
    method: 'GET',
  });
};

// ========= 工作空间相关 =========

export enum WorkspaceStatus {
  CREATING = 'CREATING', // 正在创建
  STOPPED = 'STOPPED', // 停止的，或者有在跑但没有心跳维持会话的
  LOADING = 'LOADING', // 正在启动
  RUNNING = 'RUNNING', // 运行中的
  STOPPING = 'STOPPING', // 正在停止
  BANNED = 'BANNED', // 被管理员禁用
  INVALID = 'INVALID', // 标记删除
  DELETED = 'DELETED', // 已删除
}

// 获取工作空间列表
export const queryWorkspaceList = async () => {
  return httpClient({
    path: `/workspace/status/list`,
    method: 'GET',
  });
};

// 停止工作空间
export const stopWorkspace = async (spaceKey: string) => {
  return httpClient({
    path: `/workspace/${spaceKey}/stop?force=true`,
    method: 'PUT',
  });
};

// 运行工作空间
export const runWorkspaceBySpaceKey = async (spaceKey: string) => {
  return httpClient({
    path: `/workspace/${spaceKey}/run`,
    method: 'PUT',
  });
};

export const manageWorkspaces = async (currentSpaceKey: string) => {
  try {
    // 获取所有工作空间列表
    const workspaceListResponse = await queryWorkspaceList();
    const workspaceList = workspaceListResponse?.data || [];

    // 筛选出所有运行中的工作空间
    const runningWorkspaces = workspaceList.filter((workspace: any) => workspace.status === WorkspaceStatus.RUNNING);

    // 停止所有运行中的工作空间
    for (const workspace of runningWorkspaces) {
      await stopWorkspace(workspace.spaceKey);
    }

    console.log(`Workspace ${currentSpaceKey} has been started.`);
  } catch (error) {
    console.error('Error managing workspaces:', error);
    throw error;
  }
};
